export enum CBTProgramWeekTwoStep {
    SettingGoalsStep = 'setting-goals',
    GoalSettingTipsStep = 'goal-setting-tips',
    BuildingMotivationStep = 'building-motivation',
    ProsAndConsStep = 'pros-and-cons-for-your-goals',
    WhatDidYouNoticeStep = 'what-did-you-notice',
    WeighingItUpStep = 'weighing-it-up',
    WhatAreYourGoalsStep = 'what-are-your-goals',
}

export enum CBTProgramWeekTwoSurvey {
    WhatDidYouNotice = 'week-2-goals-and-motivation',
    WeighingItUp = 'week-2-weighing-it-up',
    WhatAreYourGoals = 'week-2-what-are-your-goals',
    ProsAndCons = 'week-2-goal-pros-and-cons',
}
